module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div id=\"slate__tv__provider__selection\" class=\"slate\">\n    <div class=\"slate__wrapper\">\n        <div class=\"slate__title\" role=\"heading\" aria-level=\"1\">")
    ; __append(escapeFn( title ))
    ; __append("</div>\n        <div class=\"slate__description providers--container\" aa-region=\"live tv\">\n            <ul class=\"slate__provider__list\">\n                ")
    ;  for(var i = 0; i < providers.length; i++) { 
    ; __append("\n                    <li class=\"slate__provider__box\">\n                        <a class=\"vue-focusable\" tabindex=\"0\" role=\"button\" href=\"#\" aa-link=\"live tv|mvpd|")
    ; __append(escapeFn( providers[i].providerName ))
    ; __append("|||||||\"\n                           data-providerID=\"")
    ; __append(escapeFn( providers[i].providerID ))
    ; __append("\" data-providerName=\"")
    ; __append(escapeFn( providers[i].providerName ))
    ; __append("\">\n                            <img src=\"")
    ; __append(escapeFn( imageHost ))
    ; __append("/base/")
    ; __append(escapeFn( providers[i].providerLogo ))
    ; __append("\"\n                                 alt=\"")
    ; __append(escapeFn( providers[i].providerName ))
    ; __append(" logo\" class=\"slate__provider__box__logo ")
    ; __append(escapeFn( providers[i].providerID ))
    ; __append("\">\n                        </a>\n                    </li>\n                ")
    ;  } 
    ; __append("\n            </ul>\n        </div>\n        <div class=\"slate__divider\">\n            <span class=\"slate__divider__text\">OR</span>\n        </div>\n        <div id=\"provider__select__box\" class=\"slate__input\">\n        </div>\n    </div>\n</div>")
  }
  return __output;

}